import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from '@redux/store';
import Cookies from 'universal-cookie';
import config from '@app/config';

type IModals = {
  modals: any;
  dataModals: any;
  popups: any;
};

const initialState: IModals = {
  modals: {
    background: false,
    modalRegion: false,
    orderPhone: false,
    modalLogin: false,
    modalFreeTyres: false,
    modalInfoTyresDisks: false,
    modalCookiesInfo: false,
    modalTyresSize: false,
    modalTyresWidth: false,
    modalTyresHeight: false,
    modalTyresDiameter: false,
    modalTyresRunFlat: false,
    modalTyresCommercial: false,
    modalDisksDiameter: false,
    modalDisksFasteningPCD: false,
    modalDisksType: false,
    modalPayClick: false,
    modalShopList: false,
    activeVideo: null,
    modalAkbSpec: false,
    modalOilApi: false,
    modalOilAcea: false,
    modalOilViscosity: false,
    modalVideoWhyChoose: false,
  },
  dataModals: {
    tabInfoTyresDisks: 1,
    data: null,
  },
  popups: {
    popupCheckedRegion: false,
    popupCookies: false,
    massege: false,
    newYear: false,
    Message23: false,
    Message9: false,
  },
};

const cookies = new Cookies();

const removeCookiesRegion = () => {
  const timeCookies = new Date(new Date().getTime() + 60 * 24 * 1000 * 60 * 60);
  cookies.set('CheckedRegion', 'hide', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

const removeNewYear = () => {
  const timeCookies = new Date(new Date().getTime() + 30 * 24 * 1000 * 60 * 60);
  cookies.set('kolesoNewYearMessage', 'hide', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

const remove23Fev = () => {
  const timeCookies = new Date(new Date().getTime() + 2 * 24 * 1000 * 60 * 60);
  cookies.set('koleso23Fev', 'hide', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

const remove9May = () => {
  const timeCookies = new Date(new Date().getTime() + 2 * 24 * 1000 * 60 * 60);
  cookies.set('koleso9May', 'hide', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

const removeInfoBlockCookies = () => {
  const timeCookies = new Date(new Date().getTime() + 365 * 24 * 1000 * 60 * 60);
  cookies.set('hideFixedFooterPrivateDataPolicy', '1', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

const removeMessage = () => {
  const timeCookies = new Date(new Date().getTime() + 30 * 24 * 1000 * 60 * 60);
  cookies.set('careMessageInfo', 'hide', { path: '/', domain: config.baseDomain, expires: timeCookies });
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModalVideoWhyChoose: state => {
      state.modals.modalVideoWhyChoose = !state.modals.modalVideoWhyChoose;
    },
    setModalRegion: (state, action: PayloadAction<any>) => {
      removeCookiesRegion();
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.modalRegion = action.payload;
      state.popups.popupCheckedRegion = false;
      state.modals.background = action.payload;
    },
    setInfoCookeis: (state, action: PayloadAction<any>) => {
      state.modals.modalCookiesInfo = action.payload;
      state.modals.background = action.payload;
    },
    setModalOrderPhone: (state, action: PayloadAction<any>) => {
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.orderPhone = action.payload;
      state.modals.background = action.payload;
    },
    setModalFreeTyres: (state, action: PayloadAction<any>) => {
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.modalFreeTyres = action.payload;
      state.modals.background = action.payload;
    },
    setModalLogin: (state, action: PayloadAction<any>) => {
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.modalLogin = action.payload;
      state.modals.background = action.payload;
    },
    setModalInfoTyresDisks: (state, action: PayloadAction<any>) => {
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.modalInfoTyresDisks = action.payload;
      state.modals.background = action.payload;
    },
    setTabTyresDisks: (state, action: PayloadAction<any>) => {
      state.dataModals.tabInfoTyresDisks = action.payload;
      state.modals.background = action.payload;
    },
    setCheckedRegion: (state, action: PayloadAction<any>) => {
      !action.payload && removeCookiesRegion();
      state.popups.popupCheckedRegion = action.payload;
    },
    setNewYear: (state, action: PayloadAction<any>) => {
      !action.payload && removeNewYear();
      state.popups.newYear = action.payload;
    },
    setCookiesPopup: (state, action: PayloadAction<any>) => {
      !action.payload && removeInfoBlockCookies();
      state.popups.popupCookies = action.payload;
    },
    setMessage: (state, action: PayloadAction<any>) => {
      !action.payload && removeMessage();
      state.popups.massege = action.payload;
    },
    setModalTyresSize: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresSize = action.payload;
      state.modals.background = action.payload;
    },
    setModalTyresWidth: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresWidth = action.payload;
      state.modals.background = action.payload;
    },
    setModalTyresHeight: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresHeight = action.payload;
      state.modals.background = action.payload;
    },
    setModalTyresDiameter: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresDiameter = action.payload;
      state.modals.background = action.payload;
    },
    setModalTyresRunFlat: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresRunFlat = action.payload;
      state.modals.background = action.payload;
    },
    setModalTyresCommercial: (state, action: PayloadAction<any>) => {
      state.modals.modalTyresCommercial = action.payload;
      state.modals.background = action.payload;
    },
    setModalDisksDiameter: (state, action: PayloadAction<any>) => {
      state.modals.modalDisksDiameter = action.payload;
      state.modals.background = action.payload;
    },
    setModalDisksFasteningPCD: (state, action: PayloadAction<any>) => {
      state.modals.modalDisksFasteningPCD = action.payload;
      state.modals.background = action.payload;
    },
    setModalDisksType: (state, action: PayloadAction<any>) => {
      state.modals.modalDisksType = action.payload;
      state.modals.background = action.payload;
    },
    setActiveVideo: (state, action: PayloadAction<any>) => {
      state.modals.activeVideo = action.payload;
      state.modals.background = action.payload;
    },
    setModalPayClick: (state, action: PayloadAction<any>) => {
      state.modals.modalPayClick = action.payload;
      state.modals.background = action.payload;
    },
    setModalShopList: (state, action: PayloadAction<any>) => {
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals.modalShopList = action.payload;
      state.modals.background = action.payload;
    },
    setMessage23: (state, action: PayloadAction<any>) => {
      !action.payload && remove23Fev();
      state.popups.Message23 = action.payload;
    },
    setMessage9: (state, action: PayloadAction<any>) => {
      !action.payload && remove9May();
      state.popups.Message9 = action.payload;
    },
    setModalAkbSpec: (state, action: PayloadAction<{ nameModal: string; open?: boolean; data?: { title: string } }>) => {
      const { nameModal, open = true, data } = action.payload;
      state.modals = Object.keys(state.modals).reduce((a, b) => {
        a[b] = false;
        return a;
      }, {});
      state.modals[nameModal] = open;
      state.dataModals.data = data;
    },
    setModalOilViscosity: (state, action) => {
      state.modals.modalOilViscosity = action.payload?.open !== false;
    },
    setModalOilApi: (state, action) => {
      state.modals.modalOilApi = action.payload?.open !== false;
    },
    setModalOilAcea: (state, action) => {
      state.modals.modalOilAcea = action.payload?.open !== false;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.modal,
      };
    },
  },
});

export const {
  setModalRegion,
  setInfoCookeis,
  setModalInfoTyresDisks,
  setTabTyresDisks,
  setModalFreeTyres,
  setCheckedRegion,
  setNewYear,
  setCookiesPopup,
  setMessage,
  setModalTyresSize,
  setModalTyresWidth,
  setModalTyresHeight,
  setModalTyresDiameter,
  setModalTyresRunFlat,
  setModalTyresCommercial,
  setModalDisksDiameter,
  setModalDisksFasteningPCD,
  setModalDisksType,
  setActiveVideo,
  setModalPayClick,
  setModalShopList,
  setMessage23,
  setMessage9,
  setModalAkbSpec,
  setModalOilViscosity,
  setModalOilApi,
  setModalOilAcea,
  setModalVideoWhyChoose,
} = modalSlice.actions;

export const selectModal = (state: RootState) => state.modal.modals;
export const selectModalData = (state: RootState) => state.modal.dataModals;
export const selectPopupData = (state: RootState) => state.modal.popups;

export const modalReducer = modalSlice.reducer;
